import React from 'react';
import { Button, Label } from 'govuk-react-jsx';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBusinessVatData,
  setAnswers,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkAnswers, updateAccount } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const ConfirmVAT = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();
  const businessVatDataRedux = useSelector(getBusinessVatData);

  useTitle(
    'landlordReg.ConfirmVAT.s8',
    'Confirm company details - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const dispatch = useDispatch();

  const redirectCheckAnswers = () => {
    checkAnswers()
      .then((response) => {
        const { data } = response;

        dispatch(setAnswers(data));

        history.push('/landlordReg/check-your-answers');
      })
      .catch(() => {
        // TODO: Show error message
      });
  };

  const handleBtnClick = () => {
    updateAccount(businessVatDataRedux)
      .then(() => {
        redirectCheckAnswers();
      })
      .catch(() => {
        // TODO: Show an error message
      });
  };

  const pageModel = (
    <>
      <div className="govuk-form-group">
        <Label
          className="govuk-label--xl govuk-!-padding-bottom-7"
          isPageHeading
        >
          {copyProvider.getCopy(
            'landlordReg.ConfirmVAT.s1',
            'Confirm the company details'
          )}
        </Label>
        <Label className="govuk-label--s">
          {copyProvider.getCopy(
            'landlordReg.ConfirmVAT.s2',
            'UK VAT registration number'
          )}
        </Label>
        <p className="govuk-body govuk-!-font-size-19">
          {businessVatDataRedux && businessVatDataRedux.vatRegNumber}
        </p>
        <Label className="govuk-label--s">
          {copyProvider.getCopy('landlordReg.ConfirmVAT.s3', 'Company name')}
        </Label>
        <p className="govuk-body govuk-!-font-size-19">
          {businessVatDataRedux && businessVatDataRedux.businessName}
        </p>
        <Label className="govuk-label--s">
          {copyProvider.getCopy(
            'landlordReg.ConfirmVAT.s4',
            'Registered company address'
          )}
        </Label>
        {businessVatDataRedux && (
          <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
            <section>
              {businessVatDataRedux.businessAddressLine1 &&
                `${businessVatDataRedux.businessAddressLine1},`}
            </section>
            <section>
              {businessVatDataRedux.businessAddressLine2 &&
                `${businessVatDataRedux.businessAddressLine2},`}
            </section>
            <section>
              {businessVatDataRedux.businessAddressCity &&
                `${businessVatDataRedux.businessAddressCity},`}
            </section>
            <section>
              {businessVatDataRedux.businessAddressCounty &&
                `${businessVatDataRedux.businessAddressCounty},`}
            </section>
            <section>
              {businessVatDataRedux.businessAddressPostcode &&
                businessVatDataRedux.businessAddressPostcode}
              {businessVatDataRedux.businessAddressCountry && ','}
            </section>
            <section>
              {businessVatDataRedux.businessAddressCountry &&
                businessVatDataRedux.businessAddressCountry}
            </section>
          </div>
        )}
        <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
          <section>
            {copyProvider.getCopy(
              'landlordReg.ConfirmVAT.s7',
              'Your company address may be different from the registered company address. If this is the case you may still proceed. We will not use this address to send any letters. Contact Companies House if you need to update your company address details.'
            )}
          </section>
        </div>
        <Link
          className="govuk-link govuk-body govuk-!-font-size-19"
          to="/landlordReg/company-VAT-number"
        >
          {copyProvider.getCopy(
            'landlordReg.ConfirmVAT.s5',
            'This is not my business'
          )}
        </Link>
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'landlordReg.ConfirmVAT.s6',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default ConfirmVAT;
